import { render, staticRenderFns } from "./fragment-scroll-mark.vue?vue&type=template&id=54970047&"
import script from "./fragment-scroll-mark.vue?vue&type=script&lang=js&"
export * from "./fragment-scroll-mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports